import { TAG_STYLE } from 'transfix-ui'
import { IssueStatus, ISSUE_STATUS_LABEL } from 'constants/issueStatus'

export const ISSUE_TAG_PROPS = {
  [IssueStatus.awaiting_response]: {
    style: TAG_STYLE.warning,
    outline: false,
    label: ISSUE_STATUS_LABEL.awaiting_response,
  },
  [IssueStatus.in_progress]: {
    style: TAG_STYLE.info,
    outline: false,
    label: ISSUE_STATUS_LABEL.in_progress,
  },
  [IssueStatus.pending]: {
    style: TAG_STYLE.info,
    outline: true,
    label: ISSUE_STATUS_LABEL.pending,
  },
  [IssueStatus.resolved]: {
    style: TAG_STYLE.success,
    outline: false,
    label: ISSUE_STATUS_LABEL.resolved,
  },
}
